import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Play, Lock, Crown } from "lucide-react";

export default function Videos() {
  const { user } = useAuth();
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).finally(() => setLoading(false));
  }, [user]);

  return (
    <div className="min-h-screen max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-20" data-testid="videos-page">
      <div className="mb-12 flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="font-anton uppercase tracking-[0.3em] text-[#DD5422] text-sm mb-2">/ Cranked Up Loud</div>
          <h1 className="font-anton text-5xl md:text-7xl uppercase tracking-tight">Funny Videos</h1>
          <p className="text-[#8D9688] mt-4 max-w-2xl">Country bangers, mud bogs, pranks, and pure tailgate energy.</p>
        </div>
        {!user?.is_subscriber && (
          <Link to="/subscribe"
            className="border-2 border-[#DD5422] text-[#DD5422] px-4 py-3 font-anton uppercase tracking-widest text-xs hover:bg-[#DD5422] hover:text-[#0A0E0B] transition-colors flex items-center gap-2">
            <Crown className="w-4 h-4" /> Unlock VIP Videos
          </Link>
        )}
      </div>

      {loading ? (
        <div className="text-[#8D9688] uppercase tracking-widest" data-testid="videos-loading">Loadin' up...</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((v, i) => {
            const isLocked = v.vip_only && !v.youtube_id;
            return (
              <div key={v.id} data-testid={`video-card-${v.id}`}
                className="bg-[#151A14] border-2 border-[#2C332A] hover:border-[#DD5422] transition-colors fade-up relative"
                style={{ animationDelay: `${i * 0.05}s` }}>
                {v.vip_only && (
                  <div className="absolute top-3 left-3 z-10 bg-[#DD5422] text-[#0A0E0B] px-2 py-1 font-anton text-xs uppercase tracking-widest flex items-center gap-1">
                    <Crown className="w-3 h-3" /> VIP
                  </div>
                )}
                {active === v.id && !isLocked ? (
                  <div className="relative aspect-video">
                    <iframe
                      src={`https://www.youtube.com/embed/${v.youtube_id}?autoplay=1`}
                      title={v.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="w-full h-full"
                    />
                  </div>
                ) : isLocked ? (
                  <Link to="/subscribe" data-testid={`video-locked-${v.id}`}
                    className="relative aspect-video w-full block group overflow-hidden bg-[#0A0E0B]">
                    <div className="absolute inset-0 flex flex-col items-center justify-center bg-[#0A0E0B]/80 backdrop-blur-sm">
                      <Lock className="w-10 h-10 text-[#DD5422] mb-2" />
                      <div className="font-anton uppercase tracking-widest text-sm text-[#E5E5E5]">VIP Members Only</div>
                      <div className="text-xs uppercase tracking-widest text-[#DD5422] mt-1">Tap to unlock</div>
                    </div>
                  </Link>
                ) : (
                  <button data-testid={`video-play-${v.id}`} onClick={() => setActive(v.id)} className="relative aspect-video w-full block group overflow-hidden">
                    <img src={`https://img.youtube.com/vi/${v.youtube_id}/hqdefault.jpg`}
                      alt={v.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                    <div className="absolute inset-0 bg-[#0A0E0B]/40 group-hover:bg-[#0A0E0B]/20 transition-colors flex items-center justify-center">
                      <div className="w-16 h-16 bg-[#DD5422] flex items-center justify-center group-hover:scale-110 transition-transform">
                        <Play className="w-8 h-8 text-[#0A0E0B] ml-1" fill="#0A0E0B" />
                      </div>
                    </div>
                  </button>
                )}
                <div className="p-5">
                  <div className="text-xs uppercase tracking-[0.2em] text-[#DD5422]">{v.category}</div>
                  <div className="font-anton text-xl md:text-2xl uppercase tracking-tight mt-1">{v.title}</div>
                  <div className="text-sm text-[#8D9688] mt-1">{v.description}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
